import React from "react";
import { ResizableDrawer } from "src/components/Layout/ResizableDrawer";
import { NavigationBlockerProvider } from "src/components/NavigationBlocker";
import { type CriteriaSet } from "src/generated/hooks/form-service/requests";
import { CriteriaSettingsScreen } from "./CriteriaSettingsScreen";
import { type CriterionForEntity } from "./criterionForEntity";
import { EditConditions } from "./EditConditionsScreen";

type Props = {
  enrollmentPeriodId: string;
  criterionForEntity: CriterionForEntity;
  isOpen: boolean;
  onClose: () => void;
};

type Step = { type: "main" } | { type: "edit"; criteriaSet: CriteriaSet };

export const CriteriaSettingsDrawer: React.FC<Props> = ({
  enrollmentPeriodId,
  criterionForEntity,
  isOpen,
  onClose,
}) => {
  const [step, setStep] = React.useState<Step>({ type: "main" });
  const showMain = () => setStep({ type: "main" });

  React.useEffect(() => {
    setStep({ type: "main" });
  }, [criterionForEntity.entityId]);

  return (
    <NavigationBlockerProvider>
      {({ confirm, hasChanges }) => {
        const handleClose = async () => {
          if (!hasChanges || (await confirm())) onClose();
        };

        return (
          <ResizableDrawer
            isOpen={isOpen}
            onClose={() => {
              void handleClose();
            }}
            onCloseComplete={showMain}
          >
            {step.type === "main" ? (
              <CriteriaSettingsScreen
                enrollmentPeriodId={enrollmentPeriodId}
                criterionForEntity={criterionForEntity}
                isOpen={isOpen}
                onEditCriteriaSet={(criteriaSet) =>
                  setStep({ type: "edit", criteriaSet })
                }
              />
            ) : (
              <EditConditions
                enrollmentPeriodId={enrollmentPeriodId}
                entity={criterionForEntity}
                criteriaSet={step.criteriaSet}
                onDone={showMain}
              />
            )}
          </ResizableDrawer>
        );
      }}
    </NavigationBlockerProvider>
  );
};
